export enum InspectionType {
    Status = 0,
    Draw = 1,
}
